import ObjectFilterSelect from 'automation-ui-log-events/components/ObjectFilterSelect';
import NonEnrollmentDiagnosisPanel from 'flow-doctor-lib/components/diagnosis/non-enrollment/NonEnrollmentDiagnosisPanel';
import { jsx as _jsx } from "react/jsx-runtime";
const DIAGNOSIS_PANEL_WIDTH = 650;
const WrappedCrmObjectSelect = ({
  selectedObjectId,
  objectTypeId,
  onChange
}) => {
  return /*#__PURE__*/_jsx(ObjectFilterSelect, {
    flowObjectTypeId: objectTypeId,
    updateUrlFilters: ({
      target: {
        value
      }
    }) => onChange(isNaN(Number(value)) ? null : Number(value)),
    selectedObjectId: selectedObjectId || undefined
  });
};
const NonEnrollmentDiagnosisPanelWrapper = ({
  flowId,
  flowObjectTypeId,
  onClose
}) => {
  return /*#__PURE__*/_jsx(NonEnrollmentDiagnosisPanel, {
    width: DIAGNOSIS_PANEL_WIDTH,
    flowId: flowId,
    objectTypeId: flowObjectTypeId,
    onClose: onClose,
    CrmObjectSelectComponent: WrappedCrmObjectSelect
  });
};
export default NonEnrollmentDiagnosisPanelWrapper;